import CommunitySelectors from "community/modules/DataCatalog/components/DataSource/MyDatasources/selectors";
import { IEntityAttribute, IMetadataEntityAttributeDTO } from 'interfaces/models/EntityAttribute';

export default class MyDatasourcesSelectors extends CommunitySelectors {
  getEnterpriseAttrList(metadataAttrList: IMetadataEntityAttributeDTO[], staticAttrList: IEntityAttribute[]): Array<IEntityAttribute> {
    return staticAttrList;
  }
}